import objectValuesByToken from '../../../helpers/objectValuesByToken'

export default {
    computed: {
        modes:           {
            get() {
                return this.l_modes;
            },
            set(modes) {
                this.l_modes = modes;
            }
        },
        selectedMode:    {
            get() {
                return this.l_selectedMode;
            },
            set(mode) {
                this.l_selectedMode = mode;
            }
        },
        l_search_string: {
            get: () => {
                return app.store.state.ks_app.global_data.l_search_string;
            }
        }
    },
    methods:  {
        async loadModeList() {
            try {
                let res      = await app.sdk['rms']['data_provider_mode_list'](
                    this.userSessionToken,
                    {
                        'campaign_id':    this.userSelectedCampaigns.map(c => c.id).join(),
                        'search_string':  this.id,
                        'row_count_skip': 0,
                        'row_count_take': 999
                    },
                    true,
                    [],
                    null,
                    `${this.id}-${this._uid}`
                );
                this.l_modes = res.list.map(mode => {
                    try {
                        return {...mode, mode_json: JSON.parse(mode.mode_json)}
                    } catch (err) {
                        return {...mode, mode_json: {filters: {}, components: []}}
                    }
                });
                this.checkIfSelectedModeIsInNewList();
                return true;
            } catch (err) {
                console.log('KS-APP: loadModeList', err);
                throw err;
            }
        },
        checkIfSelectedModeIsInNewList() {
            let found = this.l_modes.findIndex((mode) => mode.id === this.l_selectedMode.id);
            if (found > -1) console.log("this.l_modes[found]", this.l_modes[found]);
            if (found === -1) {
                this.selectedMode = {
                    id:        null,
                    mode_name: null,
                    icon:      null,
                    mode_json: {filters: {}, orderBy: null, skip: null, pageSize: null, page: null, components: null}
                }
            }
        },
        setSelectedMode(mode) {
            this.l_selectedMode = JSON.parse(JSON.stringify(mode));
        },
        getSelectedMode() {
            return JSON.parse(JSON.stringify(this.l_selectedMode));
        },
        clearSelectedMode() {
            this.setSelectedMode({
                id:        null,
                mode_name: null,
                icon:      null,
                mode_json: {filters: {}, orderBy: null, skip: null, pageSize: null, page: null, components: null}
            });
        },
        getModeFromModeListById(modeId = null) {
            if (modeId) {
                let res = this.l_modes.find(m => m.id == modeId);
                if (res) return res;
                else throw 'Mode name not found';
            } else throw 'modeId Invalid';
        },
        getModeFromModeListByName(modeName = null) {
            if (modeName) {
                let res = this.l_modes.find(m => m.mode_name.toLowerCase().trim() == modeName.toLowerCase().trim());
                if (res) return res;
                else throw 'Mode name not found';
            } else throw 'modeName Invalid';
        },
        getModeFromModeListByIndex(index = null) {
            if (index !== null && !isNaN(index)) {
                let res = this.l_modes[index];
                if (res) return res;
            }
            throw 'index Invalid';
        },
        getModeFromURL() {
            if (this.$route.query.s) return app.decodeQueryStringParams(this.$route.query.s);
            else throw 'Invalid url';
        },
        getModeByCurrentConfiguration() {
            return {
                'id':                 null,
                'mode_name':          null,
                'data_provider_name': this.id,
                'icon':               null,
                'mode_json':          {
                    'filters':    this.getFilters(),
                    'orderBy':    this.getOrderBy(),
                    'skip':       this.recordsToSkipForNextPage,
                    'pageSize':   this.getPageSize(),
                    'page':       this.getPage(),
                    'components': app.mode_components.map(mc => {
                        try {
                            return {codeId: mc.codeId, config: mc.component.getComponentConfiguration()}
                        } catch (er) {
                            return {codeId: mc.codeId, config: null}
                        }
                    })
                }
            }
        },
        async selectModeById(modeId = null, load = false) {
            try {
                this.setSelectedMode(this.getModeFromModeListById(modeId));
                await this.applySelectedMode(load);
            } catch (err) {
                throw err;
            }
        },
        async selectModeByName(modeName = null, load = false) {
            try {
                this.setSelectedMode(this.getModeFromModeListByName(modeName));
                await this.applySelectedMode(load);
            } catch (err) {
                throw err;
            }
        },
        async selectModeByIndex(index = null, load = false) {
            try {
                this.setSelectedMode(this.getModeFromModeListByIndex(index));
                await this.applySelectedMode(load);
            } catch (err) {
                throw err;
            }
        },
        async selectModeFromUrl(load = false) {
            try {
                this.setSelectedMode(this.getModeFromURL());
                await this.applySelectedMode(load);
            } catch (err) {
                throw err
            }
        },
        async selectDefaultMode(load = false) {
            try {
                if (this.defaultModeId) {
                    return await this.selectModeById(this.defaultModeId, load);
                } else {
                    return await this.selectModeByName(this.defaultModeName, load);
                }
            } catch (err) {
                throw err;
            }
        },
        async applySelectedMode(load = true) {
            try {
                return await this.applyMode(this.l_selectedMode, load);
            } catch (err) {
                console.log('KS-APP: ', 'Invalid applySelectedMode', err);
                throw err;
            }
        },
        async applyMode(_mode, reload = true) {
            try {
                let mode = JSON.parse(JSON.stringify(_mode));
                if (typeof mode.mode_json.filters == 'undefined') throw 'invalid mode filters';
                let filters = objectValuesByToken.getObject(mode.mode_json.filters);
                //removing search_string if it's in the mode filters, and keeping campaign_id, facility_id/facility_id_csv as what they are currently set to in l_filters
                if (filters) filters.campaign_id = this.l_filters.campaign_id;
                if (filters) filters.facility_id = this.l_filters.facility_id;
                if (filters) filters.facility_id_csv = this.l_filters.facility_id_csv;
                if (filters) delete filters.search_string;

                /*if (this.l_search_string) {
                    filters.search_string = this.l_search_string;
                }*/

                /*Charles I commented out the page and page size  because that shouldn't be part of the modes
                * If you have 100 as your page size and then change modes you should still have 100 page size
                * I don't know why you'd want to save a page as part of the mode. We can add this back in if so*/
                this.setComponentsConfiguration(mode.mode_json.components);
                await this.updateFilters(filters, reload, {
                    'orderBy': typeof mode.mode_json.orderBy != 'undefined' ? mode.mode_json.orderBy : null,
                    /*'pageSize': typeof mode.mode_json.pageSize != 'undefined' ? mode.mode_json.pageSize : 20,
                    'page': typeof mode.mode_json.page != 'undefined' ? mode.mode_json.page : 0*/
                }, true);
                return mode;
            } catch (err) {
                console.log('KS-APP: ', 'Invalid applyMode', err);
                throw err;
            }
        },
        async insertMode(mode) {
            if (mode.mode_name !== null && mode.mode_name.length > 0) {
                try {
                    //remove campaign_id for filters;
                    //Charles/Tyrone -- save excluded filters but don't utilize them on load
                    //if(mode.mode_json.filters.campaign_id) delete mode.mode_json.filters.campaign_id;

                    let res = await app.sdk['rms']['data_provider_mode_create'](
                        this.userSessionToken,
                        {
                            'campaign_id':        this.userSelectedCampaigns.map(c => c.id).join(),
                            'data_provider_name': mode.data_provider_name,
                            'mode_name':          mode.mode_name,
                            'mode_json':          JSON.stringify(mode.mode_json),
                            'icon':               mode.icon,
                            'display_quick_icon': mode.display_quick_icon
                        },
                        true,
                        [],
                        null,
                        `${this.id}-${this._uid}`
                    );
                    return res;
                } catch (err) {
                    throw err;
                }
            }
        },
        async updateMode(mode) {
            try {
                //remove campaign_id for filters;
                //Charles/Tyrone -- save exluded filters but don't utilize them on load
                //if(mode.mode_json.filters.campaign_id) delete mode.mode_json.filters.campaign_id;
                let editMode = {
                    'filters':    JSON.parse(JSON.stringify(mode.mode_json.filters)),
                    'orderBy':    mode.mode_json.orderBy,
                    'pageSize':   mode.mode_json.pageSize,
                    'page':       mode.mode_json.page,
                    'components': mode.mode_json.components
                }
                await app.sdk['rms']['data_provider_mode_update'](
                    this.userSessionToken,
                    {
                        'data_provider_mode_id': mode.id,
                        'campaign_id':           this.userSelectedCampaigns.map(c => c.id).join(),
                        'data_provider_name':    mode.data_provider_name,
                        'mode_json':             JSON.stringify(editMode),
                        'mode_name':             mode.mode_name,
                        'icon':                  mode.icon,
                        'display_quick_icon':    mode.display_quick_icon,
                        'write_nulls':           0,
                    },
                    true,
                    [],
                    null,
                    `${this.id}-${this._uid}`
                );
                let index           = this.l_modes.findIndex(pm => pm.id == mode.id);
                this.l_modes[index] = mode;
            } catch (err) {
                throw err;
            }
        },
        getComponentsConfiguration() {
            let components = this.getComponents();
            let aux        = components.filter(cp => {
                if (cp.id !== null && typeof cp.getComponentConfiguration !== 'undefined') {
                    return cp
                }
            })
            aux            = aux.map(mc => {
                try {
                    return {id: mc.id, config: mc.getComponentConfiguration()}
                } catch (err) {
                    return {id: mc.id, config: null}
                }
            })
            return aux;
        },
        setComponentsConfiguration(components) {
            for (let cp of components) {
                let findComponent = this.l_components.find(c => c.id == cp.id);
                if (findComponent && cp.config) findComponent.setComponentConfiguration(cp.config);
            }
        }
    },
    data() {
        return {
            l_modes:        [],
            l_selectedMode: {
                id:        null,
                mode_name: null,
                icon:      null,
                mode_json: {filters: {}, orderBy: null, skip: null, pageSize: null, page: null, components: null}
            }
        }
    }
}
